module.exports = __webpack_public_path__ + "static/media/pdf.dea5ee41.svg";